(() => {
  const pool = document.getElementById('mysize-formful-pool');
  if (!pool) return;

  const qs = (sel, root = document) => root.querySelector(sel);

  const findAppBlockByFormKey = (formKey) => {
    if (!formKey) return null;
    const form = qs(`form[data-form-key="${CSS.escape(formKey)}"]`, pool);
    if (!form) return null;
    return form.closest('.shopify-app-block, .shopify-block') || form.parentElement;
  };

  const openModal = (id) => {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');

    const slot = qs('[data-formful-slot]', modal);
    if (!slot) return;

    const key =
      slot.dataset.mysizeFormKey ||
      slot.getAttribute('data-mysize-form-key') ||
      '';

    const block = findAppBlockByFormKey(key);

    if (block) {
      slot.innerHTML = '';
      slot.appendChild(block);
    } else {
      slot.innerHTML = `<p style="margin:0;">Form not found: ${key}</p>`;
    }
  };

  const closeModal = (id) => {
    const modal = document.getElementById(id);
    if (!modal) return;

    const moved = qs('.shopify-app-block, .shopify-block', modal);
    if (moved) pool.appendChild(moved);

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-mysize-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.dataset.mysizeOpen);
      return;
    }

    const closeBtn = e.target.closest('[data-mysize-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.dataset.mysizeClose);
      return;
    }

    const bg = e.target.closest('.modular.is-active');
    if (bg && e.target === bg) closeModal(bg.id);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const opened = document.querySelector('.modular.is-active[id]');
    if (opened) closeModal(opened.id);
  });
})();